import { useState, useEffect, useContext, useRef } from 'react';
import {Card, CardHeader, CardContent, Alert, AlertTitle, Button} from '@mui/material';
import { DataGrid, GridToolbar, useGridApiRef } from '@mui/x-data-grid';		//https://mui.com/x/react-data-grid/ [MIT version]
import { useTheme } from '@mui/material/styles';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';

import DeleteIcon from '@mui/icons-material/Delete';

import loadingGif from '../../Assets/loading.gif';
import Api from '../../Services/Api';
import {OPERATOR_ROLE} from '../../Config/constants.js';
import Functions from "../../Services/Functions";
import {PAGE_SIZE, pageSizeOptions} from '../../Config/constants.js';
import SpareUtilizeForm from "../Spare/SpareUtilizeForm";

import FastTextField from "../FastTextField";
import FastInfoBlock from "../FastInfoBlock";
import FormikValidation from "../FormikValidation";
import { ApWoContext } from '../../Contexts/context';
import { SignatureComponent } from '@syncfusion/ej2-react-inputs/index.js';
import { registerLicense } from '@syncfusion/ej2-base';
import ActionButton from '../ActionButton.js';

function RenderRepair(props) {
	let {user, appointment, setInEdit, isCancelled, isClosed} = props;

	const [apiResponse, setApiResponse] = useState(null)
	const [rows, setRows] = useState([]);
	const [onEdit, setOnEdit] = useState(false)
    const [localInEdit, setLocalInEdit] = useState(false) //true if data was changed without save
	const [loading, setLoading] = useState(false)
	const [displayAlert, setDisplayAlert] = useState(0)
	const [displayUtilize, setDisplayUtilize] = useState(0)
	const [lastUpdate, setLastUpdate] = useState(null);
	const apiRef = useGridApiRef();	//https://mui.com/x/api/data-grid/

	// eslint-disable-next-line
	const { showContextOverlayContext, setShowContextOverlayContext } = useContext(ApWoContext);

    const theme = useTheme();

	const formik = useFormik({
		initialValues: {
			transfer_hours: apiResponse?.repair.transfer_hours ? moment(apiResponse?.repair.transfer_hours).format('HH:mm') : "",
			work_hours: apiResponse?.repair.work_hours ? moment(apiResponse?.repair.work_hours).format('HH:mm') : "",
			description: apiResponse?.repair.description ?? "",
			warranty: apiResponse?.repair.warranty ?? "",
			price: apiResponse?.repair.price ?? "",
			repair_date: apiResponse?.repair.repair_date ? moment(apiResponse?.repair.repair_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
			return_date: apiResponse?.repair.return_date ? moment(apiResponse?.repair.return_date).format('YYYY-MM-DD') : "",
			notes: apiResponse?.repair.notes ?? "",
			signature_tecnician: apiResponse?.repair.signature_tecnician ?? "",
			signature_customer: apiResponse?.repair.signature_customer ?? "",
			technician_id: apiResponse?.tecnician.id ?? (user.roles[0].name === OPERATOR_ROLE ? user.id : ""),
			appointment_id: appointment,
			_method: onEdit ? 'put' : 'post',
		},
		validate : values => {
			setInEdit(true);
            setLocalInEdit(true);

            let errors = {}
            return errors
        },
		validationSchema: Yup.object({
			transfer_hours:
				Yup.string(),
			work_hours:
				Yup.string(),
			description:
				Yup.string()
				.max(1000, 'Lunghezza massima 1000 caratteri')
				.required('Campo obbligatorio'),
			warranty:
				Yup.string()
				.max(255, 'Lunghezza massima 255 caratteri'),
			price:
				Yup.number()
				.min(0, 'Valore minimo 0')
				.max(999999.99, 'Valore massimo 999999.99'),
			repair_date:
				Yup.date()
				.required('Campo obbligatorio'),
			return_date:
				Yup.date(),
			notes:
				Yup.string()
				.max(1000, 'Lunghezza massima 1000 caratteri'),
			technician_id:
				Yup.number()
				.integer("Valore non accettato")
				.min(1)
				.max(18446744073709551615, 'Valore non accettato')	//Bigint
				.required('Campo obbligatorio'),
			appointment_id :
				Yup.number()
				.integer("Valore non accettato")
				.min(1)
				.max(18446744073709551615, 'Valore non accettato')	//Bigint
				.required('Campo obbligatorio'),
		}),
		onSubmit: values => {
			try {
				setLoading(true);
				setDisplayAlert(0);

				if (!signatureTecnician.current.isEmpty()) {
					values.signature_tecnician = signatureTecnician.current.getSignature();
				}
				else {
					values.signature_tecnician = null;
				}
				if (!signatureCustomer.current.isEmpty()) {
					values.signature_customer = signatureCustomer.current.getSignature();
				}
				else {
					values.signature_customer = null;
				}

				let currEndpoint = onEdit ? `repair/${apiResponse.repair.id}` : 'repair';
				Api.post({endpoint: currEndpoint, body: values, contentType : 'application/json'})
					.then(response => {
						if (response.data.repair_id) {
							setOnEdit(true);
						}
						setDisplayAlert(1);
						let timer1 = setTimeout(() => {setLoading(false);clearTimeout(timer1)}, 3000);
					})
					.catch(error => {
						if (error.response?.status === 422) {
							var errors = JSON.parse(error.request.response);
							if (errors.hasOwnProperty('errors')) {
								var alertMessage = "Si sono verificati errori nei dati:";
								for (var errorField in errors.errors) {
									alertMessage += "\n" + errors.errors[errorField].join(',');
								}
								alert(alertMessage);
								setDisplayAlert(0);
								setLoading(false);
							}
							else {
								console.log(error);
							}
							return;
						}
						else {
							console.log(error);
							alert("Errore inatteso!");
						}
						setDisplayAlert(-1);
					});
			} catch (error) {
				console.log(error);
				setDisplayAlert(-1);
			}

			setInEdit(false);
            setLocalInEdit(false);
		},
		enableReinitialize: true,
	});

	registerLicense('Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXpceHZVRmJeVEB/WEs=');
	const signatureTecnician = useRef(null);
	const signatureCustomer = useRef(null);

	const clrBtnClick = (e) => {
		let id = e.target.id;
		if (id === "signature_tecnician_clear") {
			signatureTecnician.current.clear();
		}
		if (id === "signature_customer_clear") {
			signatureCustomer.current.clear();
		}
	}

	useEffect(() => {
		try {
			Api.get({endpoint: `repair/work/${props.appointment}`, contentType : 'application/json'})
				.then(response => {
					setApiResponse(response.data);
					setLastUpdate(Date.now());
					if (response.data.repair.id && response.data.repair.id !== -1) {
						if (response.data.repair.signature_tecnician) {
							signatureTecnician.current.load(response.data.repair.signature_tecnician);
						}
						if (response.data.repair.signature_customer) {
							signatureCustomer.current.load(response.data.repair.signature_customer);
						}
						setOnEdit(true);
					}
				})
				.catch(error => {
					console.log(error);
					setApiResponse(null);
					setDisplayAlert(-1);
				});

		} catch (error) {
			console.log(error);
			return (error.response ? error.response?.status : null);
		}
	}, [onEdit]);	// eslint-disable-line react-hooks/exhaustive-deps

	function newElement() {
		setDisplayUtilize(1);
	}

	function renderSpares() {
		const columns = [
			{
				field: 'quantity',
				headerName: 'Quantità',
				flex: 1,
				type: 'number',
				align: 'right',
				valueGetter: (params) => params.row.pivot.quantity ? parseFloat(params.row.pivot.quantity) : null,
				valueFormatter: (params) => params.value != null ? Functions.toDecimal(params.value) : '',
			},
			{
				field: 'code',
				headerName: 'Codice',
				flex: 1,
			},
			{
				field: 'short_description',
				headerName: 'Ricambio',
				flex: 2,
			},
			{
				field: 'price',
				headerName: 'Prezzo totale',
				flex: 1,
				type: 'number',
				align: 'right',
				valueGetter: (params) => params.row.pivot.price ? parseFloat(params.row.pivot.price) : null,
				valueFormatter: (params) => params.value != null ? Functions.toDecimal(params.value) : '',
			},
			{
				field: 'id',
				headerName: 'Azioni',
				flex: 1,
				valueGetter: (params) => {
					return params.row.pivot.id
				},
				renderCell: (params) => {
					function onDelete(e) {
						e.stopPropagation(); // don't select this row after clicking
						if (window.confirm("Confermare l'eliminazione DEFINITIVA dell'Assegnazione?")) {
							if (window.confirm("Eliminare l'Assegnazione?")) {
								try {
									Api.del({endpoint: `spare/utilize/${params.value}`, contentType : 'application/json'})
										.then(response => {
											setDisplayAlert(1);
											setLastUpdate(Date.now());
										})
										.catch(error => {
											console.log(JSON.stringify(error));
											setDisplayAlert(-1);
										});
								} catch (error) {
									console.log(JSON.stringify(error));
									setDisplayAlert(-1);
								}
							}
						}
					};
					return <>
						<ActionButton title={"Elimina Assegnazione"} disabled={isClosed} onClick={onDelete}>
							<DeleteIcon />
						</ActionButton>
					</>
				}
			},
		]

		return (
			<>
				<h5 className="mt-3">Lista Materiali</h5>
				<DataGrid
					getRowId={(row) => row.idHash}
					//onRowDoubleClick={hook}
					sx={{ minHeight: '300px' }}
					rows={rows}
					columns={columns}
					initialState={{
						pagination: {
							paginationModel: {
								pageSize: PAGE_SIZE,
							},
						},
					}}
					apiRef={apiRef}
					slots={{
						toolbar: GridToolbar,
					}}
					slotProps={{
						columnsPanel: {
							disableHideAllButton: true,
						}
					}}
					pageSizeOptions={pageSizeOptions}
				/>

				<div className="mt-2">
					<Button
						variant="contained"
						onClick={newElement}
						disabled={isClosed}
					>
						Aggiungi Ricambio
					</Button>
				</div>
			</>
		);
	}

	const handleCloseUtilize = () => {
		setDisplayUtilize(0);
		setLastUpdate(Date.now());
	};

	useEffect(() => {
		if (onEdit && apiResponse.repair.id !== -1) {
			try {
				Api.get({endpoint: `spare/lists/${apiResponse.repair.id}/utilizes`, contentType : 'application/json'})
					.then(response => {
						setRows(response.data.utilizes);
					})
					.catch(error => {
						console.log(error);
						setRows([]);
						setDisplayAlert(-1);
					});
			} catch (error) {
				console.log(error);
				return (error.response ? error.response?.status : null);
			}
		}
	}, [lastUpdate, onEdit]);	// eslint-disable-line react-hooks/exhaustive-deps

	const generatePdf = () => {
        if (localInEdit) {
            alert("Salvare il documento per poter effettuare la stampa!");
            return;
        }
		if (onEdit && props.appointment) {
			setDisplayAlert(0);
			try {
                setLoading(true);
				Api.get({endpoint: `export/generate-repair-pdf/${apiResponse.repair.id}`, responseType : 'blob'})
					.then(response => {
                        Functions.openBlob(response.data);
                        setLoading(false);
					})
					.catch(error => {
						console.log(error);
						setDisplayAlert(-1);
                        setLoading(false);
					});
			} catch (error) {
				console.log(error);
				return (error.response ? error.response?.status : null);
			}
		}
	};

	return (
		<>
			{isCancelled && (
				<Alert severity="error" sx={{marginBottom: '10px'}}>
					<AlertTitle>ATTENZIONE</AlertTitle>
					Stai lavorando su un appuntamento che è stato cancellato!
				</Alert>
			)}

			{isClosed && (
				<Alert severity="warning" sx={{marginBottom: '10px'}}>
					<AlertTitle>ATTENZIONE</AlertTitle>
					Stai guardando un appuntamento che è stato segnato come CHIUSO!
				</Alert>
			)}

			<Card>
				<CardHeader
					title="Ordine di servizio Riparazione"
					subheader="Visualizza e modifica i dati del servizio di Riparazione"
				/>
				<CardContent sx={{ pt: 0 }}>
					<form
						autoComplete="off"
						noValidate
						onSubmit={formik.handleSubmit}
					>
						<div key="transfer_hours_work_hours_technician" className="row styled">
							<div key="transfer_hours" className="col-md-3">
								<FastTextField loading={loading} formik={formik} label="Ore viaggio" field="transfer_hours" type="time" />
							</div>
							<div key="work_hours" className="col-md-3">
								<FastTextField loading={loading} formik={formik} label="Ore di lavoro" field="work_hours" type="time" />
							</div>
							<div key="technician" className="col-md-6">
								<FastInfoBlock label="Tecnico che ha effettuato l'intervento" content={`${apiResponse?.tecnician.surname} ${apiResponse?.tecnician.name}`} {...props} />
							</div>
						</div>
						<div key="r_description" className="row styled">
							<div key="description" className="col-md-12">
								<FastTextField loading={loading} required formik={formik} label="Descrizione dell'intervento" field="description"
									multiline
									rows={4}
								/>
							</div>
						</div>
						<div key="warranty_price_repair_date_return_date" className="row styled">
							<div key="warranty" className="col-md-3">
								<FastTextField loading={loading} formik={formik} label="Garanzia" field="warranty" />
							</div>
							<div key="price" className="col-md-3">
								<FastTextField loading={loading} formik={formik} label="Prezzo manodopera" field="price" type="number" />
							</div>
							<div key="repair_date" className="col-md-3">
								<FastTextField loading={loading} required formik={formik} label="Data intervento" field="repair_date" type="date" />
							</div>
							<div key="return_date" className="col-md-3">
								<FastTextField loading={loading} formik={formik} label="Data prossimo intervento" field="return_date" type="date" />
							</div>
						</div>
						<div key="r_notes" className="row styled">
							<div key="warranty" className="col-md-12">
								<FastTextField loading={loading} formik={formik} label="Note di intervento" field="notes"
									multiline
									rows={4}
								/>
							</div>
						</div>

						<div key="signature" className="row styled" style={{'borderBottom': '1px solid gray'}}>
							<div className='col-md-6'>
								<div key="signature_label" className="row styled" style={{'borderTop': '1px solid gray'}}>
									<div key="signature_tecnician_label" className="col-md-12">
										Firma del tecnico
									</div>
								</div>
								<div key="signature_tecnician" className="signature-control">
									<div className="signature_canvas">
										<SignatureComponent width={350} height={100} id="signature_tecnician" ref={signatureTecnician}></SignatureComponent>
									</div>
								</div>
								<div key="signature_tecnician_clear" className="">
									<Button id="signature_tecnician_clear" variant="outlined" disabled={loading} onClick={(e) => clrBtnClick(e)}>
										Cancella firma
									</Button>
									<p style={{'marginTop': '10px', 'fontSize': '0.8em'}}>Prima di stampare,<br />salvare il documento per acquisire la firma</p>
								</div>
							</div>
							<div className='col-md-6'>
								<div key="signature_label" className="row styled" style={{'borderTop': '1px solid gray'}}>
									<div key="signature_customer_label" className="col-md-12">
										Firma del cliente
									</div>
								</div>
								<div key="signature_customer" className=" signature-control">
									<div className="signature_canvas">
										<SignatureComponent width={350} height={100} id="signature_customer" ref={signatureCustomer}></SignatureComponent>
									</div>
								</div>
								<div key="signature_customer_clear" className="">
									<Button id="signature_customer_clear" variant="outlined" disabled={loading} onClick={(e) => clrBtnClick(e)}>
										Cancella firma
									</Button>
									<p style={{'marginTop': '10px', 'fontSize': '0.8em'}}>Prima di stampare,<br />salvare il documento per acquisire la firma</p>
								</div>
							</div>
						</div>

						<div className="row styled">
                            {loading && (
                                <div className="col">
                                    <>
                                    {displayAlert === 0 && (
                                        <img className="pl-3" src={loadingGif} alt="Loading..."/>
                                    )}
                                    </>
                                    <>
                                    {displayAlert === -1 && (
                                        <Alert severity="error">Si è verificato un errore imprevisto. Riprovare più tardi</Alert>
                                    )}
                                    </>
                                    <>
                                    {displayAlert === 1 && (
                                        <Alert severity="success">
                                            {onEdit ? (
                                                <>Dati modificati con successo!</>
                                            ) : (
                                                <>Dati salvati con successo!</>
                                            )}
                                        </Alert>
                                    )}
                                    </>
                                </div>
                            )}
                            {!loading && (
                                <>
                                    <div className="col-md-6">
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            disabled={isClosed}
                                        >
                                            {onEdit ? (
                                                <>Modifica dati</>
                                            ) : (
                                                <>Invia dati</>
                                            )}
                                        </Button>
                                    </div>
                                    <div className="col-md-6">
                                        <Button
                                            variant="contained"
                                            type="button"
                                            size="small"
                                            onClick={generatePdf}
                                            style={{backgroundColor: theme.palette.secondary.background, fontSize: '0.8em'}}
                                        >
                                            Stampa ordine di servizio (PDF)
                                        </Button>
                                    </div>
                                </>
                            )}
						</div>

					</form>
					<FormikValidation formikValues={formik.values} formikErrors={formik.errors} formikTouched={formik.touched} />
					{onEdit &&
						renderSpares()
					}
				</CardContent>
			</Card>

			<FormikValidation formikValues={formik.values} formikErrors={formik.errors} formikTouched={formik.touched} tech={true} />
			<SpareUtilizeForm
				open={displayUtilize}
				onClose={handleCloseUtilize}
				repair={apiResponse?.repair}
			/>
		</>
	)
}

export default RenderRepair;
